export default "__VITE_ASSET__898c65fa__"